import _objectSpread from "/www/wwwroot/shishai_admin_fe/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/www/wwwroot/shishai_admin_fe/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar

import 'nprogress/nprogress.css'; // progress bar style

import { getToken } from '@/utils/auth'; // get token from cookie

import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/auth-redirect', '/openLogin', '/apply', '/application', '/goHightSchool', '/upSchool']; // no redirect whitelist

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasRoles, _yield$store$dispatch, admin_menu_paths, accessRoutes;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            NProgress.start(); // set page title

            document.title = getPageTitle(to.meta.title); // determine whether the user has logged in

            hasToken = getToken();

            if (!hasToken) {
              _context.next = 35;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 9;
              break;
            }

            // if is logged in, redirect to the home page
            next({
              path: '/'
            });
            NProgress.done(); // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939

            _context.next = 33;
            break;

          case 9:
            // determine whether the user has obtained his permission roles through getInfo
            hasRoles = store.getters.roles && store.getters.roles.length > 0;

            if (!hasRoles) {
              _context.next = 14;
              break;
            }

            next();
            _context.next = 33;
            break;

          case 14:
            _context.prev = 14;
            _context.next = 17;
            return store.dispatch('user/getInfo');

          case 17:
            _yield$store$dispatch = _context.sent;
            admin_menu_paths = _yield$store$dispatch.admin_menu_paths;
            _context.next = 21;
            return store.dispatch('permission/generateRoutes', admin_menu_paths);

          case 21:
            accessRoutes = _context.sent;
            // dynamically add accessible routes
            router.addRoutes(accessRoutes); // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record

            next(_objectSpread(_objectSpread({}, to), {}, {
              replace: true
            }));
            _context.next = 33;
            break;

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](14);
            _context.next = 30;
            return store.dispatch('user/resetToken');

          case 30:
            Message.error(_context.t0 || 'Has Error');
            next("/login?redirect=".concat(to.path));
            NProgress.done();

          case 33:
            _context.next = 36;
            break;

          case 35:
            /* has no token*/
            if (whiteList.indexOf(to.path) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/login?redirect=".concat(to.fullPath));
              NProgress.done();
            }

          case 36:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 26]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});